// interval is milliseconds
export function getExpireTime(interval = 60000) {
  return Date.now() + interval;
}
